import { call, put, takeEvery } from 'redux-saga/effects'
import {
  //add visit
  addVisitTypeData,
  addVisitTypeSuccess,
  addVisitTypeFailed,
  //update visit
  updateVisitTypeData,
  updateVisitTypeDataSuccess,
  updateVisitTypeDataFailed,
  //delete Speciality
  deleteVisitTypesData,
  deleteVisitTypeSuccess,
  deleteVisitTypeFailed,
  //get visit
  getVisitTypeData,
  getVisitTypeDataFailed,
  getVisitTypeDataSuccess,

  //addBanner
  addBannerData,
  addBannerSuccess,
  addBannerFailed,
  //updateBanner
  updateBannerData,
  updateBannerDataSuccess,
  updateBannerDataFailed,
  //getBanner
  getBannerData,
  getBannerDataSuccess,
  getBannerDataFailed,
  //deleteBanner
  deleteBannersData,
  deleteBannerSuccess,
  deleteBannerFailed,

  //add Speciality
  addSpecialityData,
  addSpecialityDataFailed,
  addSpecialityDataSuccess,
  //update Speciality
  updateSpecialityData,
  updateSpecialityDataFailed,
  updateSpecialityDataSuccess,
  //delete Speciality
  deleteSpecialityData,
  deleteSpecialityDataFailed,
  deleteSpecialityDataSuccess,
  //get Speciality
  getSpecialityData,
  getSpecialityDataFailed,
  getSpecialityDataSuccess,

  //add Education
  addEducationData,
  addEducationDataFailed,
  addEducationDataSuccess,
  //update Education
  updateEducationData,
  updateEducationDataFailed,
  updateEducationDataSuccess,
  //delete Education
  deleteEducationData,
  deleteEducationDataFailed,
  deleteEducationDataSuccess,
  //get Education
  getEducationData,
  getEducationDataFailed,
  getEducationDataSuccess,

  //add SpecialInterest
  addSpecialInterestData,
  addSpecialInterestDataFailed,
  addSpecialInterestDataSuccess,
  //update SpecialInterest
  updateSpecialInterestData,
  updateSpecialInterestDataFailed,
  updateSpecialInterestDataSuccess,
  //delete SpecialInterest
  deleteSpecialInterestData,
  deleteSpecialInterestDataFailed,
  deleteSpecialInterestDataSuccess,
  //get SpecialInterest
  getSpecialInterestData,
  getSpecialInterestDataFailed,
  getSpecialInterestDataSuccess,

  //add State
  addStateData,
  addStateDataFailed,
  addStateDataSuccess,
  //update State
  updateStateData,
  updateStateDataFailed,
  updateStateDataSuccess,
  //delete State
  deleteStateData,
  deleteStateDataFailed,
  deleteStateDataSuccess,
  //get State
  getStateData,
  getStateDataFailed,
  getStateDataSuccess,
  // Taluk List
  talukListApiCall,
  talukListApiSuccess,
  talukListApiFailed,

  // Add Taluk
  addTalukApiCall,
  addTalukApiSuccess,
  addTalukApiFailed,

  // Update Taluk
  updateTalukApiCall,
  updateTalukApiSuccess,
  updateTalukApiFailed,

  // delete Taluk
  deleteTalukApiCall,
  deleteTalukApiSuccess,
  deleteTalukApiFailed,
  // Taluk Details
  talukDetailsApiCall,
  talukDetailsSuccess,
  talukDetailsFailed,

  //uploadImage
  uploadImage,
  uploadImageSuccess,
  uploadImageFailed,
} from './slice'
import { API } from '../../services'

//Visit
function* addVisitType({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addVisitType, payload)
    if (response.data && response.status === 200) {
      yield put(addVisitTypeSuccess({ payload: response?.data }))
    } else {
      yield put(addVisitTypeFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addVisitTypeFailed({ message: error?.message }))
  }
}

function* updateVisitType({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateVisitType, payload)
    if (response.data && response.status === 200) {
      yield put(updateVisitTypeDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateVisitTypeDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateVisitTypeDataFailed({ message: error?.message }))
  }
}

function* getVisitType() {
  try {
    const response = yield call(API.settingApi.visitType)
    if (response.data && response.status === 200) {
      yield put(getVisitTypeDataSuccess({ payload: response?.data }))
    } else {
      yield put(getVisitTypeDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getVisitTypeDataFailed({ message: error?.message }))
  }
}

function* deleteVisitType({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteVisitType, payload)
    if (response.data && response.status === 200) {
      yield put(deleteVisitTypeSuccess({ payload: response?.data }))
    } else {
      yield put(deleteVisitTypeFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteVisitTypeFailed({ message: error?.message }))
  }
}

//Banner
function* addBanner({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addBanner, payload)
    if (response.data && response.status === 200) {
      yield put(addBannerSuccess({ payload: response?.data }))
    } else {
      yield put(addBannerFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addBannerFailed({ message: error?.message }))
  }
}

function* updateBanner({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateBanner, payload)
    if (response.data && response.status === 200) {
      yield put(updateBannerDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateBannerDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateBannerDataFailed({ message: error?.message }))
  }
}

function* getBanner() {
  try {
    const response = yield call(API.settingApi.getBanner)
    if (response.data && response.status === 200) {
      yield put(getBannerDataSuccess({ payload: response?.data }))
    } else {
      yield put(getBannerDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getBannerDataFailed({ message: error?.message }))
  }
}

function* deleteBanner({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteBanner, payload)
    if (response.data && response.status === 200) {
      yield put(deleteBannerSuccess({ payload: response?.data }))
    } else {
      yield put(deleteBannerFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteBannerFailed({ message: error?.message }))
  }
}

//Speciality
function* addSpeciality({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addSpeciality, payload)
    if (response.data && response.status === 200) {
      yield put(addSpecialityDataSuccess({ payload: response?.data }))
    } else {
      yield put(addSpecialityDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSpecialityDataFailed({ message: error?.message }))
  }
}

function* updateSpeciality({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateSpeciality, payload)
    if (response.data && response.status === 200) {
      yield put(updateSpecialityDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateSpecialityDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSpecialityDataFailed({ message: error?.message }))
  }
}

function* getSpeciality() {
  try {
    const response = yield call(API.settingApi.speciality)
    if (response.data && response.status === 200) {
      yield put(getSpecialityDataSuccess({ payload: response?.data }))
    } else {
      yield put(getSpecialityDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSpecialityDataFailed({ message: error?.message }))
  }
}

function* deleteSpeciality({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteSpeciality, payload)
    if (response.data && response.status === 200) {
      yield put(deleteSpecialityDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteSpecialityDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSpecialityDataFailed({ message: error?.message }))
  }
}

//Education
function* addEducation({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addEducation, payload)
    if (response.data && response.status === 200) {
      yield put(addEducationDataSuccess({ payload: response?.data }))
    } else {
      yield put(addEducationDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addEducationDataFailed({ message: error?.message }))
  }
}

function* updateEducation({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateEducation, payload)
    if (response.data && response.status === 200) {
      yield put(updateEducationDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateEducationDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateEducationDataFailed({ message: error?.message }))
  }
}

function* getEducation() {
  try {
    const response = yield call(API.settingApi.education)
    if (response.data && response.status === 200) {
      yield put(getEducationDataSuccess({ payload: response?.data }))
    } else {
      yield put(getEducationDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getEducationDataFailed({ message: error?.message }))
  }
}

function* deleteEducation({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteEducation, payload)
    if (response.data && response.status === 200) {
      yield put(deleteEducationDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteEducationDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteEducationDataFailed({ message: error?.message }))
  }
}

//SpecialInterest
function* addSpecialInterest({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addSpecialInterest, payload)
    if (response.data && response.status === 200) {
      yield put(addSpecialInterestDataSuccess({ payload: response?.data }))
    } else {
      yield put(addSpecialInterestDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addSpecialInterestDataFailed({ message: error?.message }))
  }
}

function* updateSpecialInterest({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateSpecialInterest, payload)
    if (response.data && response.status === 200) {
      yield put(updateSpecialInterestDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateSpecialInterestDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateSpecialInterestDataFailed({ message: error?.message }))
  }
}

function* getSpecialInterest() {
  try {
    const response = yield call(API.settingApi.specialInterest)
    if (response.data && response.status === 200) {
      yield put(getSpecialInterestDataSuccess({ payload: response?.data }))
    } else {
      yield put(getSpecialInterestDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getSpecialInterestDataFailed({ message: error?.message }))
  }
}

function* deleteSpecialInterest({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteSpecialInterest, payload)
    if (response.data && response.status === 200) {
      yield put(deleteSpecialInterestDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteSpecialInterestDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteSpecialInterestDataFailed({ message: error?.message }))
  }
}

//States
function* addState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addState, payload)
    if (response.data && response.status === 200) {
      yield put(addStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(addStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addStateDataFailed({ message: error?.message }))
  }
}

function* updateState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateState, payload)
    if (response.data && response.status === 200) {
      yield put(updateStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(updateStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateStateDataFailed({ message: error?.message }))
  }
}

function* getState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.stateList, payload)
    if (response.data && response.status === 200) {
      yield put(getStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(getStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(getStateDataFailed({ message: error?.message }))
  }
}

function* deleteState({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteState, payload)
    if (response.data && response.status === 200) {
      yield put(deleteStateDataSuccess({ payload: response?.data }))
    } else {
      yield put(deleteStateDataFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteStateDataFailed({ message: error?.message }))
  }
}

function* talukListApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.talukListApi, payload)

    if (response.data && response.status === 200) {
      yield put(talukListApiSuccess({ payload: response?.data }))
    } else {
      yield put(talukListApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(talukListApiFailed({ message: error?.message }))
  }
}
function* addTalukApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.addTaluk, payload)

    if (response.data && response.status === 200) {
      yield put(addTalukApiSuccess({ payload: response?.data }))
    } else {
      yield put(addTalukApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(addTalukApiFailed({ message: error?.message }))
  }
}
function* updateTalukApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.updateTaluk, payload)

    if (response.data && response.status === 200) {
      yield put(updateTalukApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateTalukApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(updateTalukApiFailed({ message: error?.message }))
  }
}
function* deleteTalukApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.deleteTaluk, payload)

    if (response.data && response.status === 200) {
      yield put(deleteTalukApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteTalukApiFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(deleteTalukApiFailed({ message: error?.message }))
  }
}
function* talukDetailsApi({ type, payload }) {
  try {
    const response = yield call(API.settingApi.talukDetails, payload)

    if (response.data && response.status === 200) {
      yield put(talukDetailsSuccess({ payload: response?.data }))
    } else {
      yield put(talukDetailsFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(talukDetailsFailed({ message: error?.message }))
  }
}

//Upload Image
function* postImage({ type, payload }) {
  try {
    const response = yield call(API.commonApi.postImage, payload)

    if (response.data && response.status === 200) {
      yield put(uploadImageSuccess({ payload: response?.data }))
    } else {
      yield put(uploadImageFailed({ message: response.message }))
    }
  } catch (error) {
    yield put(uploadImageFailed({ message: error?.message }))
  }
}

function* settingSaga() {
  yield takeEvery(updateVisitTypeData, updateVisitType)
  yield takeEvery(addVisitTypeData, addVisitType)
  yield takeEvery(getVisitTypeData, getVisitType)
  yield takeEvery(deleteVisitTypesData, deleteVisitType)

  yield takeEvery(updateBannerData, updateBanner)
  yield takeEvery(addBannerData, addBanner)
  yield takeEvery(getBannerData, getBanner)
  yield takeEvery(deleteBannersData, deleteBanner)

  yield takeEvery(updateSpecialityData, updateSpeciality)
  yield takeEvery(addSpecialityData, addSpeciality)
  yield takeEvery(getSpecialityData, getSpeciality)
  yield takeEvery(deleteSpecialityData, deleteSpeciality)

  yield takeEvery(updateEducationData, updateEducation)
  yield takeEvery(addEducationData, addEducation)
  yield takeEvery(getEducationData, getEducation)
  yield takeEvery(deleteEducationData, deleteEducation)

  yield takeEvery(updateSpecialInterestData, updateSpecialInterest)
  yield takeEvery(addSpecialInterestData, addSpecialInterest)
  yield takeEvery(getSpecialInterestData, getSpecialInterest)
  yield takeEvery(deleteSpecialInterestData, deleteSpecialInterest)

  yield takeEvery(updateStateData, updateState)
  yield takeEvery(addStateData, addState)
  yield takeEvery(getStateData, getState)
  yield takeEvery(deleteStateData, deleteState)

  yield takeEvery(uploadImage, postImage)

  // Taluk
  yield takeEvery(talukListApiCall, talukListApi)
  yield takeEvery(addTalukApiCall, addTalukApi)
  yield takeEvery(updateTalukApiCall, updateTalukApi)
  yield takeEvery(deleteTalukApiCall, deleteTalukApi)
  yield takeEvery(talukDetailsApiCall, talukDetailsApi)
}

export default settingSaga
